
<div class="global-background-div">


    <!-- Information panel -->
    <div class="panel-top panel-type-dark">
        <p class="pannel_information_highlighted">
            {{this.languageService.Strings.contactPageStrings.box_top_message_title}}
        </p>
        <p class="pannel_information" *ngFor="let string_value of languageService.Strings.contactPageStrings.box_top_message_list">
            {{string_value}}
        </p>
    </div>


    <div class="form_title">
        {{this.languageService.Strings.contactPageStrings.form_title}}
    </div>

        
    <!-- Form Section -->
    <div class="bottom_view_container">

        <!-- Left columns -->
        <div class="column-left">

            <!-- Contact form -->
            <div class="global_form_div">
                <form 
                    [formGroup]="formControlGroup_Contact" 
                    (submit)="submit()"
                    >
                    <!-- Full name -->
                    <div class="text_full_width_div">
                        <mat-form-field class="text_form_field" appearance="fill">
                            <mat-label>{{this.languageService.Strings.contactPageStrings.box_fullName}}</mat-label> 
                            <input 
                                formControlName="fullName"
                                matInput
                                type="text" 
                                placeholder=""
                                maxlength="maximumMessageLength_SingleLine"
                                [errorStateMatcher]="matcher" 
                                required 
                                autocomplete="off"
                                value="">
                            <mat-error *ngIf="formControlGroup_Contact.controls['fullName'].hasError('required')">
                                {{this.languageService.Strings.contactPageStrings.error_requiredField}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- Company -->
                    <div class="text_full_width_div">
                        <mat-form-field class="text_form_field" appearance="fill">
                            <mat-label>{{this.languageService.Strings.contactPageStrings.box_company}}</mat-label> 
                            <input 
                                formControlName="company"
                                matInput
                                type="text" 
                                placeholder=""
                                maxlength="maximumMessageLength_SingleLine"
                                [errorStateMatcher]="matcher"  
                                autocomplete="off"
                                value="">
                            <mat-error *ngIf="formControlGroup_Contact.controls['company'].hasError('required')">
                                {{this.languageService.Strings.contactPageStrings.error_requiredField}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- Phone -->
                    <div class="text_full_width_div">
                        <mat-form-field class="text_form_field" appearance="fill">
                            <mat-label>{{this.languageService.Strings.contactPageStrings.box_phone}}</mat-label> 
                            <input 
                                formControlName="phone"
                                matInput
                                type="text" 
                                placeholder=""
                                maxlength="maximumMessageLength_SingleLine"
                                [errorStateMatcher]="matcher"  
                                autocomplete="off"
                                value="">
                            <mat-error *ngIf="formControlGroup_Contact.controls['phone'].hasError('required')">
                                {{this.languageService.Strings.contactPageStrings.error_requiredField}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- Email -->
                    <div class="text_full_width_div">
                        <mat-form-field class="text_form_field" appearance="fill">
                            <mat-label>{{this.languageService.Strings.contactPageStrings.box_email}}</mat-label>      
                            <input 
                                formControlName="email"
                                matInput
                                type="text" 
                                placeholder=""
                                maxlength="maximumMessageLength_SingleLine"
                                [errorStateMatcher]="matcher" 
                                required 
                                autocomplete="off">
                            <mat-error *ngIf="formControlGroup_Contact.controls['email'].hasError('required')">
                                {{this.languageService.Strings.contactPageStrings.error_requiredField}}
                            </mat-error>  
                        </mat-form-field>
                    </div>
                    <!-- Geographical Area -->
                    <div class="text_full_width_div">
                        <mat-form-field class="text_form_field" appearance="fill">
                            <mat-label>{{this.languageService.Strings.contactPageStrings.box_geographicalArea}}</mat-label>      
                            <input 
                                formControlName="geographicalArea"
                                matInput
                                type="text" 
                                placeholder=""
                                maxlength="maximumMessageLength_SingleLine"
                                [errorStateMatcher]="matcher"  
                                autocomplete="off">
                        </mat-form-field>
                    </div>
                    <!-- Message -->
                    <div class="text_full_width_div">
                        <mat-form-field class="text_form_field" appearance="fill">
                            <mat-label>{{this.languageService.Strings.contactPageStrings.box_message}}</mat-label>     
                            <textarea   
                                formControlName="message"
                                matInput
                                type="text" 
                                placeholder=""
                                maxlength="maximumMessageLength_MultiLine"
                                rows="15"
                                required
                                [errorStateMatcher]="matcher"  
                                autocomplete="off"
                                value="">
                            </textarea>
                            <mat-error *ngIf="formControlGroup_Contact.controls['message'].hasError('required')">
                                {{this.languageService.Strings.contactPageStrings.error_requiredField}}
                            </mat-error>
                            <mat-hint
                                align="end">{{formControlGroup_Contact.controls['message'].value.length}} / {{maximumMessageLength_MultiLine}}
                            </mat-hint>     
                        </mat-form-field>
                    </div>
                    <!-- Privacy policy check box -->
                    <div class="check_box_container">
                        <mat-checkbox  
                            formControlName="checkBox_privacyPolicy"
                            class="check_box" 
                            color="primary"
                            (change)="handleChangeCheckBox_PrivacyPolicy($event)"
                            [checked]=false>
                            {{this.languageService.Strings.contactPageStrings.box_policy_1}}
                        </mat-checkbox>
                    </div>
                    <!-- Publicity check box -->
                    <div class="check_box_container">
                        <mat-checkbox  
                            formControlName="checkBox_publicity"
                            class="check_box" 
                            color="primary"
                            (change)="handleChangeCheckBox_Publicity($event)"
                            [checked]=false>
                            {{this.languageService.Strings.contactPageStrings.box_policy_2}}
                        </mat-checkbox>
                    </div>
                    <!-- Submit button. Only in 'input' or 'editing' mode -->
                    <div class="base_buttons_div">
                        <button 
                            mat-raised-button  
                            color="primary"
                            class="base_buttons"  
                            type="submit" 
                            value="submit"
                            button [disabled]="!formControlGroup_Contact.valid">
                                {{this.languageService.Strings.contactPageStrings.button_submit}} 
                        </button>
                    </div>                
                </form>
            </div>       
        </div>


        <!-- Right column -->
        <div class="column-right">
            <!--Data protection based info -->
            <div class="data_protection_div">
                <div class="data_protection_title">
                    {{this.languageService.Strings.contactPageStrings.data_protection_title}}
                </div>
                <div class="data_protection_section" *ngFor="let dataDict of this.languageService.Strings.contactPageStrings.data_protection_sections">
                    <p class="data_protection_section_title">
                        {{dataDict.title}}
                    </p>
                    <p class="data_protection_section_text">
                        {{dataDict.text}}
                    </p>
                </div>
            </div>
        </div>
    </div>


</div>



<!-- Waiting spinner -->

<div *ngIf="(displayWaitingSpiner)" >
    <app-waiting-spinner [waitingMessage]="waitingMessage" ></app-waiting-spinner> 
</div>